/**
 * What to do when the client picked in the header is no longer the one whose
 * draft is open on screen.
 *
 *  none   — they are the same client: nothing to do
 *  follow — switch the panel to the new client (nothing would be lost)
 *  ask    — the open draft has typing that was never saved: ask first
 *           (save / throw away / stay), never drop it silently
 */
export type ClientSwitchDecision = 'none' | 'follow' | 'ask';

export function clientSwitchDecision(
  shownClientId: string | null,
  pickedClientId: string | null,
  hasUnsavedTyping: boolean,
): ClientSwitchDecision {
  if (shownClientId === pickedClientId) return 'none';
  return hasUnsavedTyping && shownClientId !== null ? 'ask' : 'follow';
}

/** Leaving or reloading the page asks the browser to warn only while there is typing to lose. */
export function shouldWarnOnLeave(hasUnsavedTyping: boolean): boolean {
  return hasUnsavedTyping;
}
